<template>
    <div class="row">

              <div class="col-12 col-md-6 order-md-2">

                <!-- Card -->
                <div class="card bg-light border ml-md-4">
                  <div class="card-body">

                    <!-- Text -->
                    <p class="mb-2">
                      Password requirements
                    </p>

                    <!-- Text -->
                    <p class="small text-muted mb-2">
                      To create a new password, you have to meet all of the following requirements:
                    </p>

                    <!-- List group -->
                    <ul class="small text-muted pl-4 mb-0">
                      <li>
                        Minimum 6 characters
                      </li>
                      <li>
                        Can’t be the same as a previous password
                      </li>
                    </ul>

                  </div>
                </div>

              </div>
              <div class="col-12 col-md-6">

                <ValidationObserver ref="form" v-slot="{ passes }">
                    <form @submit.prevent="passes(submit)">
                            <ValidationProvider name="current_password" vid="current_password" rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label for="password">Current Password</label>
                                    <input type="password" class="form-control" :class="[{'is-invalid': errors.length}]"
                                        id="password" v-model="form.current_password">
                                    <div class="invalid-feedback" v-for="(error, index) in errors" :key="'current_password' + index">
                                        {{ error }}
                                    </div>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider name="Password" vid="password" rules="required|min:6" v-slot="{ errors }">
                                <div class="form-group">
                                    <label for="password">Password</label>
                                    <input type="password" class="form-control" :class="[{'is-invalid': errors.length}]"
                                        id="password" v-model="form.password">
                                    <div class="invalid-feedback" v-for="(error, index) in errors" :key="'password' + index">
                                        {{ error }}
                                    </div>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider name="Confirm Password" vid="passwordConfirmation" rules="required|confirmed:password" v-slot="{ errors }">
                                <div class="form-group">
                                    <label for="password_confirmation">Confirm Password</label>
                                    <input type="password" class="form-control" :class="[{'is-invalid': errors.length}]" id="password_confirmation"
                                    v-model="form.password_confirmation">
                                    <div class="invalid-feedback" v-for="(error, index) in errors" :key="'password_confirmation' + index">
                                        {{ error }}
                                    </div>
                                </div>
                            </ValidationProvider>

                        <button class="btn btn-lg btn-block btn-primary" :class="[{'disabled': sending}]" type="submit" :disable="sending">Update Password <div v-if="sending" class="spinner-border text-light spinner-border-sm ml-2" role="status"></div></button>

                    </form>
                    </ValidationObserver>
              </div>


            </div>

</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { isError422 } from "../../utils/response";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, confirmed, min } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Required'
});
extend('confirmed', confirmed);
extend('min', min);

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },

    data() {
        return {
            loading: true,
            sending: false,
            data: false,
            form: {
                current_password: null,
                password: null,
                password_confirmation: null,
            }
        };
    },

    computed: {
        ...mapGetters({
            agency: "auth/agency",
            user: "auth/user",
        }),
    },

    created() {

    },

    methods: {
        // Submit update form
        async submit() {
            this.sending = true;

            await axios.get('/csrf-cookie')
            await axios.put('/user/password', this.form).then(() => {
                this.$toast.success('Your password has been updated');
            })
            .catch((err) =>
            {
                if (isError422(err)) {
                    const errors = err.response.data.errors;
                    console.log(errors)
                    this.$refs.form.setErrors(errors);
                    return;
                }
                this.$toast.error('There has been an error. Please try again later');
            })
            .then(() => {
                this.sending = false;
            });
        },
    },
};
</script>
